<div class="image-zoom">
  <mat-icon svgIcon="glass-minus"
            (click)="decreaseZoomStep()"></mat-icon>
  <input type="range" min="1" [max]="MAX_SCALE"
         [value]="scale"
         (input)="zoomInputChanged($event)"
         (mouseup)="hideImageOverlay()"
         (mousedown)="showImageOverlay()"
         step="0.01">
  <mat-icon svgIcon="glass-plus"
            (click)="increaseZoomStep()"></mat-icon>
</div>
